// extracted by mini-css-extract-plugin
module.exports = {"root":"AddNetworkForm_root__3OmUN","submit":"AddNetworkForm_submit__1_wui"};